import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloating from "./WhatsAppFloating";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-sand text-ink flex flex-col">
      <Header />
      <main className="flex-1 pt-24">{children}</main>
      <Footer />
      <WhatsAppFloating />
    </div>
  );
}
